import { useQueryClient } from "@tanstack/react-query";
import { FeePostReviewTables } from "features/fees/post/FeePostReviewTables";
import {
  feeChargeEventPublish,
  getFeeChargeEventListQueryKey,
  useFeeChargeEventRetrieveSuspense,
} from "gen/endpoints/fee-charge-event/fee-charge-event";
import React from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Form from "shared/components/form/Form";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { PageWizardFormFooter } from "shared/components/layout/PageWizard";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";

export const FeePostReviewPostingPage: React.FC = () => {
  const { t } = useTranslation(["fees", "common"]);
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { fundFamilyId, feeChargeEventId } = useRequiredStringParams();

  const { data: feeChargeEventData } = useFeeChargeEventRetrieveSuspense(
    fundFamilyId,
    feeChargeEventId,
  );

  const onSuccess = async () => {
    await queryClient.invalidateQueries({
      queryKey: getFeeChargeEventListQueryKey(fundFamilyId),
    });
    navigate(
      rootRoute({}).fundFamilies({}).fundFamily({ fundFamilyId }).fees({}).$,
    );
  };

  const form = useForm({
    defaultValues: {},
  });

  return (
    <PageContent>
      <Form
        form={form}
        onSubmit={async () =>
          await feeChargeEventPublish(fundFamilyId, feeChargeEventId)
        }
        onSuccess={onSuccess}
        successMessage={t("fees:postFees.success", {
          date: feeChargeEventData.fee_charge_daterange_rich_name,
        })}
      >
        <PageHeader
          size="sm"
          title={t("fees:postFees.review.title")}
          workflowName={t("fees:feeBasisBreakdown.superTitle")}
          badge={{
            type: "default",
            text: feeChargeEventData.fee_charge_daterange_rich_name,
          }}
        />
        <PageBody>
          <FeePostReviewTables
            fundFamilyId={fundFamilyId}
            feeChargeEventId={feeChargeEventId}
          />
          <PageWizardFormFooter />
        </PageBody>
      </Form>
    </PageContent>
  );
};
